export default "__VITE_ASSET__BgKkm_sV__"